import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AccountDetailsBody, DetailsTabs } from './AccountDetails.styled';
import AccountDetailHeader from './AccountDetailHeader';
import AccountDetailTabListContainer from './AccountDetailTabListcontainer';
import ShipToAddress from 'src/pages/more/pages/accounts/components/shipToAddress';
import AccountDetailsCard from './AccountDetailCard';
import UserAccess from './UserAccess';
import { accDetailsTabs } from './accountListConstants';
import AccountNotes from 'src/pages/more/pages/accounts/components/AccountDetails/AccountNotes';
import UnsavedChanges from 'src/pages/scheduleSurgery/components/surgery/notifications/UnsavedChanges';
import {
    setUnsavedChange,
    setIsEdit,
    setShowUnsaved,
    setCommonCancel,
    setAccountDetailTabAction,
    updateAccountDetails,
    getAccountDetailss,
    setFavoritePhysician,
    setShowPopup,
    setPopupCloseFromHeader,
    setShipToAddressEdit,
    setTemplateNoteAccount,
    setTemplateNoteChangeAccount,
} from 'src/pages/more/redux/actions/index.js';
import { PHYSICIAN_LIST } from '../../../physicians/physicianData.js';
import AssociatedAccountsDesktop from 'src/pages/more/pages/accounts/components/AccountDetails/AssociatedPhysicians.jsx';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import AddedMoreThanTenItems from 'src/pages/equity/components/surgery/notifications/AddedMoreThanTenItems';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { logErrorToConsole } from 'src/utils/util';

const AccountDetails = (props) => {
    const dispatch = useDispatch();
    const physicianList = PHYSICIAN_LIST;
    const [unsavedTabchange, setunsavedTabchange] = useState(false);
    const [templateNotesPopup, setTemplateNotesPopup] = useState(false);
    const [tabState, setTabState] = useState('');
    const { t } = useTranslation();
    const selectedOption = useSelector(
        (state) => state.accountReducer.selectedOption
    );

    const shipToAddressEdit = useSelector(
        (state) => state.accountReducer.shipToAddressEdit
    );

    const shipToAddress = useSelector(
        (state) => state.accountReducer.accountDetails.shipToAddress
    );
    const [shipToAddressDetails, setShipToAddressDetails] =
        useState(shipToAddress);

    const [, setAccountTabActiveId] = useState(null);

    const templateNoteAccount = useSelector(
        (state) => state.accountReducer.templateNoteAccount
    );
    const staArray =
        shipToAddress &&
        shipToAddress.map((shipValues) => ({
            defaultNontissueShipTo: shipValues.isNonTissueSelected || false,
            defaultTissueShipTo: shipValues.isTissueSelected || false,
            defaultUnidRodShipTo: shipValues.isUnidRodSelected || false,
            sapAccountId: shipValues.accountNumber,
        }));
    const [selectedSTAArray, setSelectedSTAArray] = useState([]);
    const { selectedTabIdAccount, tabListsAccount } = useSelector(
        (state) => state.accountReducer
    );

    const { physicians } = useSelector(
        (state) => state.loginReducer.moreVisibility
    );

    const [templateNote, setTemplateNote] = useState('');

    // const [templateAccountNote, setTemplateAccountNote] = useState('');
    const [tissueChecked, setTissueChecked] = useState(false);
    const [nonTissueChecked, setNonTissueChecked] = useState(false);
    const [unidRodChecked, setUnidRodChecked] = useState(false);

    const accountDet = useSelector(
        (state) => state.accountReducer.accountDetails.accountDetails
    );

    const isEditCheck = useSelector((state) => state.accountReducer.isEdit);

    useEffectWithErrorLogging(() => {
        setTemplateNote(accountDet && accountDet.carrierNotes);
    }, [accountDet]);
    const onTabSwitchHandler = (Id) => {
        if (commonUnsavedchanges || isEditCheck || shipToAddressEdit) {
            setunsavedTabchange(true);
            setTabState(Id);
        } else {
            setAccountTabActiveId(Id);
            dispatch(setAccountDetailTabAction({ selectedTabIdAccount: Id }));
        }
    };
    // useEffectWithErrorLogging(() => {
    //     console.log('heree');
    //     setAccountTabActiveId('accountDetails');
    // }, []);
    useEffectWithErrorLogging(() => {
        const tabListsDetails = accDetailsTabs()?.filter(
            (x) =>
                tabListsAccount?.findIndex((tabList) => tabList === x.id) != -1
        );
        if (tabListsDetails?.length > 0) {
            // setOrderDetailTabs(tabListsDetails);
            setAccountTabActiveId(selectedTabIdAccount);
        }
    }, [tabListsAccount]);

    const accountNotes = useSelector(
        (state) =>
            state.accountReducer.accountDetails.noteDetails &&
            state.accountReducer.accountDetails.noteDetails.notes
    );
    const [carrierPickup, setCarrierPickup] = useState(
        accountDet && accountDet.carrierPickupNotifications === 'Yes'
            ? 'Yes'
            : 'No'
    );
    const options =
        accountDet &&
        accountDet.carriersOption &&
        accountDet.carriersOption.map((item) => {
            return {
                value: item && item.carrierValue,
                label: item && item.carrierLabel,
            };
        });
    const [carrierOptions, setCarrierOptions] = useState({});
    const [selectedCarrier, setSelectedCarrier] = useState({});

    useEffectWithErrorLogging(() => {
        setCarrierPickup(
            accountDet && accountDet.carrierPickupNotifications === 'Yes'
                ? 'Yes'
                : 'No'
        );
        setCarrierOptions(options);
        setSelectedCarrier({
            label: accountDet && accountDet.carrierLabelDisplay,
            value: accountDet && accountDet.carrierValueDisplay,
        });
    }, [accountDet]);
    const handleChange = (selectValue) => {
        const clickeddOption = options.filter((v) => v.value === selectValue);

        dispatch(setUnsavedChange(true));
        setSelectedCarrier({
            label: clickeddOption[0].label,
            value: clickeddOption[0].value,
        });
    };
    const templateNoteChange = useSelector(
        (state) => state.accountReducer.templateNoteChangeAccount
    );
    useEffectWithErrorLogging(() => {
        // dispatch(
        //     getAccountDetailss({
        //         accountId: props.selectedAccount.accountId,
        //     })
        // );
        // setTemplateNote(accountDet && accountDet.carrierNotes);
        //dispatch(setTemplateNoteAccount(accountNotes && accountNotes));
        if (!templateNoteChange) {
            if (accountNotes) {
            } else {
                dispatch(setTemplateNoteAccount(''));
            }
        }
        dispatch(setCommonCancel(false));
        dispatch(setUnsavedChange(false));
        dispatch(setShowUnsaved(false));
        dispatch(setIsEdit(false));
        dispatch(setPopupCloseFromHeader(false));
        setSelectedSTAArray(staArray && staArray);
        dispatch(setShipToAddressEdit(false));
    }, []);

    const commonUnsavedchanges = useSelector(
        (state) => state.accountReducer.commonUnsavedchanges
    );
    const commonCancel = useSelector(
        (state) => state.accountReducer.commonCancel
    );
    const showUnsaved = useSelector(
        (state) => state.accountReducer.showUnsaved
    );

    const userAccessDetails = useSelector(
        (state) => state.accountReducer.accountDetails.userAccessDetails
    );

    const associatedPhysicians = useSelector(
        (state) => state.accountReducer.accountDetails.associatedPhysicians
    );

    const selectedAccount = useSelector(
        (state) => state.accountReducer.selectedAccount
    );
    const popupCloseFromHeader = useSelector(
        (state) => state.accountReducer.popupClose
    );
    const detailsLoading = useSelector(
        (state) => state.accountReducer.detailsLoading
    );
    useEffectWithErrorLogging(() => {}, [popupCloseFromHeader]);
    const handleDiscardChanges = () => {
        setSelectedCarrier({
            label: accountDet && accountDet.carrierLabelDisplay,
            value: accountDet && accountDet.carrierValueDisplay,
        });
        setCarrierPickup(
            accountDet && accountDet.carrierPickupNotifications === 'Yes'
                ? 'Yes'
                : 'No'
        );
        if (unsavedTabchange) {
            setAccountTabActiveId(tabState);
            dispatch(
                setAccountDetailTabAction({ selectedTabIdAccount: tabState })
            );
        }

        dispatch(setTemplateNoteAccount(accountNotes && accountNotes));
        setTemplateNote(accountDet && accountDet.carrierNotes);
        if (popupCloseFromHeader) {
            dispatch(setShowPopup(false));
            setAccountTabActiveId('accountDetails');
            dispatch(
                setAccountDetailTabAction({
                    selectedTabIdAccount: 'accountDetails',
                })
            );
        }
        setunsavedTabchange(false);
        dispatch(setUnsavedChange(false));
        dispatch(setIsEdit(false));
        dispatch(setShipToAddressEdit(false));

        // dispatch(setShowPopup(false));
        dispatch(setCommonCancel(false));
        dispatch(setUnsavedChange(false));
    };
    const handleSaveAndExit = () => {
        setunsavedTabchange(false);
        dispatch(setIsEdit(true));
        dispatch(setShipToAddressEdit(true));

        dispatch(setShowUnsaved(false));
        dispatch(setUnsavedChange(false));
        dispatch(setCommonCancel(false));
        dispatch(setCommonCancel(false));
    };
    let reportRequest = {
        accountNumber: selectedAccount.accountId,
        carrier: selectedCarrier
            ? selectedCarrier.value
                ? selectedCarrier.value
                : ''
            : '',

        carrierNotes: templateNote ? templateNote : '',
        carrierPickupNotifications: carrierPickup === 'Yes' ? true : false,
        defaultAPIShipMethods: selectedSTAArray ? selectedSTAArray : staArray,
        noteDetails: templateNoteAccount ? templateNoteAccount : '',
    };

    const handleFavourite = (account) => {
        dispatch(
            setFavoritePhysician(account.physicianId, !account.isFavorite, true)
        );
    };
    const statusMessage = useSelector(
        (state) => state.accountReducer.updateStatusMessage
    );
    const fromAccountSearch = useSelector(
        (state) => state.accountReducer.fromAccountSearchNew
    );

    useEffectWithErrorLogging(() => {
        if (statusMessage === 'Update success.')
            dispatch(
                getAccountDetailss({ accountId: selectedAccount.accountId })
            );
    }, [statusMessage]);
    const onSave = () => {
        dispatch(setTemplateNoteChangeAccount(false));
        dispatch(setTemplateNoteAccount(''));
        dispatch(
            updateAccountDetails(
                reportRequest,
                selectedOption && selectedOption.label
            )
        );
        dispatch(setUnsavedChange(false));
        dispatch(setIsEdit(false));
        dispatch(setShowUnsaved(false));
        // dispatch(getAccountDetailss({ accountId: selectedAccount.accountId }));
    };
    const saveShipToAddress = () => {
        dispatch(updateAccountDetails(reportRequest));
        dispatch(setShipToAddressEdit(false));
    };
    return (
        <>
            {detailsLoading === false ? (
                <AccountDetailsBody>
                    <AccountDetailHeader
                        isFromPhysician={props.isFromPhysician}
                        account={props.accountDetail}
                        onClose={props.handleClose}
                        selectedAccount={props.selectedAccount}
                        accountDet={accountDet}
                        fromSearch={fromAccountSearch}
                        employeeRole={props.employeeRole}
                        isAccountPage = {props.isAccountPage}
                    />

                    {/* <AccountDetailsTabs/> */}
                    <DetailsTabs>
                        <AccountDetailTabListContainer
                            accountDetailTabList={accDetailsTabs().filter(
                                (tab) =>
                                    tab.id === 'associatedPhysicians'
                                        ? physicians
                                        : true
                            )}
                            tabActiveId={selectedTabIdAccount}
                            tabSwitch={onTabSwitchHandler}
                        />
                    </DetailsTabs>

                    {selectedTabIdAccount === 'accountDetails' && (
                        <AccountDetailsCard
                            accountDet={accountDet}
                            // selectedOption={selectedOption}
                            // setSelectedOption={setSelectedOption}
                            carrierPickup={carrierPickup}
                            setCarrierPickup={setCarrierPickup}
                            templateNote={templateNote}
                            setTemplateNote={setTemplateNote}
                            onSave={onSave}
                            carrierOptions={carrierOptions}
                            selectedCarrier={selectedCarrier}
                            setSelectedCarrier={setSelectedCarrier}
                            handleChange={handleChange}
                            employeeRole={props.employeeRole}
                            templateNotesPopup={templateNotesPopup}
                            setTemplateNotesPopup={setTemplateNotesPopup}
                        />
                    )}
                    {selectedTabIdAccount === 'shipToAddress' && (
                        <ShipToAddress
                            shipToAddress={shipToAddress}
                            tissueChecked={tissueChecked}
                            setTissueChecked={setTissueChecked}
                            nonTissueChecked={nonTissueChecked}
                            setNonTissueChecked={setNonTissueChecked}
                            unidRodChecked={unidRodChecked}
                            setUnidRodChecked={setUnidRodChecked}
                            onSave={saveShipToAddress}
                            shipToAddressDetails={shipToAddressDetails}
                            setShipToAddressDetails={setShipToAddressDetails}
                            setSelectedSTAArray={setSelectedSTAArray}
                            account={props.selectedAccount}
                            employeeRole={props.employeeRole}
                            // setisEdit={setisEdit}
                            // isEdit={isEdit}
                        />
                    )}
                    {selectedTabIdAccount === 'associatedPhysicians' && (
                        <AssociatedAccountsDesktop
                            physicianList={physicianList}
                            isFromAccount={true}
                            associatedPhysicians={associatedPhysicians}
                            handleFavourite={handleFavourite}
                            employeeRole={props.employeeRole}
                        />
                    )}
                    {selectedTabIdAccount === 'notes' && (
                        <AccountNotes
                            // templateNote={templateAccountNote}
                            // setTemplateNote={setTemplateAccountNote}
                            onClose={props.handleClose}
                            onSave={onSave}
                            employeeRole={props.employeeRole}
                            templateNotesPopup={templateNotesPopup}
                            setTemplateNotesPopup={setTemplateNotesPopup}
                            selectedTabIdAccount={selectedTabIdAccount}
                        />
                    )}
                    {selectedTabIdAccount === 'userAccess' && (
                        <UserAccess userAccessDetails={userAccessDetails} />
                    )}
                    {commonCancel ||
                    (showUnsaved && commonUnsavedchanges) ||
                    unsavedTabchange ||
                    (isEditCheck && commonCancel) ? (
                        <UnsavedChanges
                            onDiscard={handleDiscardChanges}
                            onClose={handleSaveAndExit}
                            continueText={t('more.common.conedit')}
                            fromSettingsClose={handleSaveAndExit}
                            fromMore={true}
                        />
                    ) : null}
                    {templateNotesPopup ? (
                        <AddedMoreThanTenItems
                            title={t('common.itemFormTitle')}
                            onClose={() => {
                                try {
                                    setTemplateNotesPopup(false);
                                } catch (error) {
                                    logErrorToConsole(error);
                                }
                            }}
                            opacity={'1'}
                            zIndex={999999999}
                            background={'#000000cc 0% 0% no-repeat padding-box'}
                        />
                    ) : null}
                </AccountDetailsBody>
            ) : (
                <Spinner id="more-accountDetails-accountDetails-loadingSpinner" animation="border" variant="primary"></Spinner>
            )}
        </>
    );
};

export default AccountDetails;
